export default __webpack_public_path__ + "static/media/video.f886aec6.png";